import { render, staticRenderFns } from "./LeaveBalance.vue?vue&type=template&id=447aa254&"
import script from "./LeaveBalance.vue?vue&type=script&lang=js&"
export * from "./LeaveBalance.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalance.vue?vue&type=style&index=0&id=447aa254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports